export default __webpack_public_path__ + "static/delivery-3f7416850bdb6526eb609f59d1b7b11f.png";